import { Tooltip, Typography } from "@kyan/ui";

export interface KrystalsTooltipProps {
  children: React.ReactNode;
  disabled?: boolean;
}

export const KrystalsTooltip: React.FC<KrystalsTooltipProps> = ({
  children,
  disabled,
}) => (
  <Tooltip
    avoidCollisions
    side="right"
    align="center"
    disabled={disabled}
    content={
      <Typography>
        Total Krystals earned <br />
        from trading, referrals, <br />
        bug bounties, and <br />
        competitions.
      </Typography>
    }
  >
    {children}
  </Tooltip>
);
